export default __webpack_public_path__ + "static/media/Space.1c578bf5.png";